import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
/**
 * A log time in the row's log zone, with "my time" below when the browser is
 * in another zone. `seconds` are Unix seconds, as the board stores them.
 */
export var LogTime = function (_a) {
    var seconds = _a.seconds, zone = _a.zone, format = _a.format;
    if (seconds === null || seconds === undefined)
        return _jsx("span", { children: "-" });
    var instant = seconds * 1000;
    var mine = format.mine(instant, zone);
    return (_jsxs(Box, { component: "span", sx: { display: "block", whiteSpace: "nowrap" }, children: [_jsx("span", { className: "log-time", children: format.format(instant, zone) }), mine ? (_jsx(Typography, { component: "span", variant: "body2", className: "log-time-mine", sx: { display: "block", color: "text.secondary" }, children: mine })) : null] }));
};
